/* eslint-disable react-hooks/exhaustive-deps */
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import ChangeHistory from "./ChangeHistory/ChangeHistory";
import Footer from "./Footer";
import useForm from "./utils/hooks/useForm";
import UpdatePenaltyForm from "./UpdatePenaltyForm";
import useReasonsForPenalizeByResourceOrSpace from "./utils/hooks/useReasonsForPenalizeByResourceOrSpace";

const UpdatePenaltyFormDialog = ({
    loadingRequest, 
    dialog, data, 
    currentPenaltyForm,
    updateAction
}) => {
    const reasonsForPenalizeByResourceOrSpace = useReasonsForPenalizeByResourceOrSpace({
        data, updatePenaltyDialog: dialog,
        currentPenaltyForm
    });
    const form = useForm({
        loadingRequest, 
        currentPenaltyForm,
        updatePenaltyDialog: dialog
    });
    return (
        <DialogAlertAction 
            show={dialog.value}
            toggleShow={dialog.toggle}
            variant="secondary"
            title="¿Deseas editar la sanción del alumno?"
            contentComponent={
                <UpdatePenaltyForm
                    subtitle="Recuerda que para editar la sanción, debes modificar alguno de los campos."
                    data={{
                        ...data,
                        reasonsForPenalizeByResourceOrSpace
                    }}
                    form={form}
                    historyComponent={
                        <ChangeHistory 
                            loadingRequest={loadingRequest} 
                            form={form.value}
                            student={currentPenaltyForm?.student}/>
                    }/>}
            widthContent="100%"
            minWidth="650px"
            spacingContainer="10px">
            <Footer 
                form={form} 
                updateAction={updateAction}
                closeDialog={dialog.hide}/>
        </DialogAlertAction>
    );
}

export default UpdatePenaltyFormDialog;